import { defineMessages } from 'react-intl';

export default defineMessages({
  bannerADSForClubLife: {
    id: 'app.modules.services.mainPage.bannerADSForClubLife',
    defaultMessage: 'Banner ADS For Club Life',
  },
  appPushNotifications: {
    id: 'app.modules.services.mainPage.appPushNotifications',
    defaultMessage: 'App - Push Notifications',
  },
  editBannerAdvertisement: {
    id: 'app.modules.communication.bannerADSForClubLife.titles.editBannerAdvertisement',
    defaultMessage: 'Edit Banner Advertisement',
  },
  newBannerAdvertisement: {
    id: 'app.modules.communication.bannerADSForClubLife.titles.newBannerAdvertisement',
    defaultMessage: 'New Banner Advertisement',
  },
  titleOfTheAdvertisement: {
    id: 'app.modules.communication.bannerADSForClubLife.note.titleOfTheAdvertisement',
    defaultMessage: 'Title of the advertisement.',
  },
  tappingOnAdWillWillURL: {
    id: 'app.modules.communication.bannerADSForClubLife.note.tappingOnAdWillWillURL',
    defaultMessage: 'Tapping on the ad will C this URL.',
  },
  imageShouldBe: {
    id: 'app.modules.communication.bannerADSForClubLife.note.imageShouldBe',
    defaultMessage: 'Image should be a PNG or JPEG with a 16:9 aspect ratio (1920x1080 pixels).',
  },
  editPushNotification: {
    id: 'app.modules.communication.appPushNotifications.titles.editPushNotification',
    defaultMessage: 'Edit Push Notification',
  },
  newPushNotification: {
    id: 'app.modules.communication.appPushNotifications.titles.newPushNotification',
    defaultMessage: 'New Push Notification',
  },
  showOnClubLifeKeytag: {
    id: 'app.modules.communication.appPushNotifications.label.showOnClubLifeKeytag',
    defaultMessage: 'Show On Club Life Keytag',
  },
  shownAfterMemberClicks: {
    id: 'app.modules.communication.appPushNotifications.note.shownAfterMemberClicks',
    defaultMessage: 'Note: Description is only shown after a member clicks on the notification.',
  },
  membersMustHaveTheClubLifeApp: {
    id: 'app.modules.communication.appPushNotifications.note.membersMustHaveTheClubLifeApp',
    defaultMessage: `Members must have the Club Life app installed to see this notification on their iPhone / Android phone. It will appear in their phone notifications even if the Club Life app isn't currently running.`,
  },
});
